// Utility functions for the Answer Logs component

/**
 * Formats cost value to display as currency
 * @param {number} cost - The cost value
 * @returns {string} Formatted cost string
 */
export const formatCost = (cost) => {
  if (!cost && cost !== 0) return "N/A";
  return `${parseFloat(cost).toFixed(3)}$`;
};

/**
 * Formats date string for display in the logs table
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatLogDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString();
};

/**
 * Maps API answer data to table format
 * @param {Object} answer - Raw answer data from API
 * @returns {Object} Formatted answer data for table display
 */
export const mapAnswerData = (answer) => ({
  id: answer.answer_id,
  chatId: answer.chat_id,
  userId: answer.user_id,
  userName: answer.user_name || "N/A",
  orgName: answer.org_name || "N/A",
  createdAt: formatLogDate(answer.created_at),
  status: answer.status,
  tokens: answer.total_tokens,
  cost: formatCost(answer.total_price),
});
